import { Form } from 'antd';
import { memo } from 'react';

import { CurrencyWrapper } from 'app/components/commons/Currency/CurrencyWrapper/CurrencyWrapper';
import { BasicInfo } from 'app/components/commons/Form/Rooms/BasicInfo/BasicInfo';
import { Beds } from 'app/components/commons/Form/Rooms/Beds/Beds';
import { Features } from 'app/components/commons/Form/Rooms/Features/Features';
import { Pictures } from 'app/components/commons/Form/Rooms/Pictures/Pictures';
import { useGetHotel } from 'app/hooks/data/hotels/useHotel';

export const RoomForm = memo(() => {
  const form = Form.useFormInstance();
  const hotelId = Form.useWatch(['hotelId'], form);
  const { data: hotel } = useGetHotel(hotelId);

  return (
    <CurrencyWrapper hotel={hotel}>
      <BasicInfo hotel={hotel} />
      <Beds />
      <Features />
      <Pictures />
    </CurrencyWrapper>
  );
});

RoomForm.displayName = 'RoomForm';
